<template>

  <div class="w-100 bg-primary">
    <div class="bgImgRight">
      <div class="container py-3">
        <Breadcrumb :home="home" :model="breadcrumbItems"/>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row sticky-title">
      <div class="col pt-1">
        <header class="container d-flex justify-content-start w-100 pt-3 pb-2">
          <h1 class="text-primary mt-2 mb-2 ps-1">Subscription</h1>
        </header>
      </div>
    </div>
    <div class="container fs-14">
      <div class="col">
        <p>{{ message }}</p>
      </div>
    </div>
  </div>

</template>

<script lang="ts" src="./SubscriptionConfirmation.ts"></script>

<style lang="scss" scoped>

</style>



